import { useCallback, useEffect, useState } from 'react'

const MAX_PRESENCE_AGE = 30000
const PRESENCE_BUFFER_INTERVAL_MS = 5000

const bufferedPresence = new Map<number, number>()

const usePresenceStore = () => {
  const [presentEndUserIds, setPresentEndUserIds] = useState<Set<number>>(
    new Set()
  )

  const setEndUserPresent = useCallback((id: number) => {
    bufferedPresence.set(id, Date.now())
  }, [])

  useEffect(() => {
    const updatePresence = () => {
      const presentIds = new Set(
        [...bufferedPresence]
          .filter((entry: number[]) => entry[1] > Date.now() - MAX_PRESENCE_AGE)
          .map((entry: number[]) => entry[0])
      )
      for (const id of presentIds) {
        if (!presentEndUserIds.has(id)) {
          setPresentEndUserIds(presentIds)
          return
        }
      }
      for (const id of presentEndUserIds) {
        if (!presentIds.has(id)) {
          setPresentEndUserIds(presentIds)
          return
        }
      }
    }
    updatePresence()
    const updatePresenceInterval = setInterval(
      updatePresence,
      PRESENCE_BUFFER_INTERVAL_MS
    )
    return () => clearInterval(updatePresenceInterval)
  }, [presentEndUserIds, setPresentEndUserIds])

  return {
    presentEndUserIds,
    setEndUserPresent,
  }
}

export default usePresenceStore
